import CrossIcon from "../../Icons/CrossIcon";
import { themeAtom } from "../../atoms";
import { FileErrorIcon, FileSuccessIcon } from "./FileStatuses";
import { TFilesWithError } from "./types";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface IFileUploadList {
  files: Pick<File, "name" | "lastModified">[];
  removeFile: (fileName: string) => void;
  errors: TFilesWithError;
  progressByFileName?: Record<string, number>;
  className?: string;
}

const FileUploadList: React.FC<IFileUploadList> = ({ files, removeFile, errors, progressByFileName, className }) => {
  const theme = useAtomValue(themeAtom);

  const listClasses = twMerge("flex max-h-[293px] w-[537px] flex-col overflow-y-auto", className);

  return files && files.length > 0 ? (
    <div className={listClasses}>
      {files.map((file) => (
        <div
          className={twMerge(
            "group border-b py-4 text-[16px] first:py-2 first:pb-4 last:border-none",
            theme.headerComponent.notifications.border,
            theme.uwhcAssistant.text,
          )}
          key={`${file.name}-${file.lastModified}`}
        >
          <div className="flex flex-row items-center gap-4">
            {errors[file.name] ? <FileErrorIcon /> : <FileSuccessIcon />}
            <span
              className="mr-auto flex-1 overflow-hidden text-ellipsis whitespace-nowrap"
              data-test="file-uploader__file-name"
            >
              {file.name}
            </span>
            {progressByFileName && (
              <div className="h-2 w-24 overflow-hidden rounded-full bg-[#d9e2df]" aria-label="Document upload progress">
                <div
                  className="h-full rounded-full bg-[#00854a] transition-all duration-300"
                  style={{ width: `${progressByFileName[file.name] ?? 0}%` }}
                />
              </div>
            )}
            <CrossIcon
              className="mr-4 cursor-pointer opacity-0 group-hover:opacity-100"
              onClick={() => removeFile(file.name)}
            />
          </div>

          {errors[file.name] && (
            <p className="mt-1 block w-full text-xs text-[#F44C45]">
              There was an issue with this file. Please try uploading it again.
            </p>
          )}
        </div>
      ))}
    </div>
  ) : null;
};

export default FileUploadList;
